import { useState } from "react";

import { Button, ErrorPage, PageLayout } from "@ezmid/components-library/";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router";

import { useGetBackOfficeGetLessonQuery } from "../../../api/lesson.generated";
import { ParamId } from "../../../enums/types";
import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";
import { LessonPageContent } from "../organisms/LessonPageContent";

export function LessonDetailPage() {
  const { id }: ParamId = useParams();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { currentData, isError } = useGetBackOfficeGetLessonQuery({
    id: id || "",
  });
  const navigate = useNavigate();
  const courseId = (location.state as { courseId?: string })?.courseId;
  const [isCreateContentModalOpen, setIsCreateContentModalOpen] =
    useState<boolean>(false);

  const enTranslations = currentData?.translations?.find(
    ({ language }) => language === "en"
  );
  const deTranslations = currentData?.translations?.find(
    ({ language }) => language === "de"
  );

  const lessonName =
    i18n.language === "en-GB" ? enTranslations?.name : deTranslations?.name;

  return isError ? (
    <ErrorPage
      errorMessageText={t("app.page.error.page.not.found")}
      messageForUser={t("app.page.error.defaultMessage")}
      hasGoBackButton
      buttonText={t("app.goToDasboard")}
      onButtonClick={() => navigate(makeRoute(AllRoutes.DASHBOARD))}
    />
  ) : (
    <PageLayout
      title={lessonName || ""}
      navigation={
        <div className="mr-2 flex gap-2">
          <Button
            type="button"
            onClick={() =>
              courseId
                ? navigate(makeRoute(AllRoutes.COURSE_DETAIL, { id: courseId }))
                : navigate(makeRoute(AllRoutes.COURSES_LIST))
            }
          >
            {t("button.back")}
          </Button>
          <Button
            type="button"
            leftIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => {
              setIsCreateContentModalOpen(true);
            }}
          >
            {t("course.lesson.create.content")}
          </Button>
        </div>
      }
    >
      <LessonPageContent
        isCreateContentModalOpen={isCreateContentModalOpen}
        onCloseCreateContentModal={() => setIsCreateContentModalOpen(false)}
      />
    </PageLayout>
  );
}
